/**
 * Removes all localStorage keys whose names start with "sb-" (Supabase auth keys).
 * Used on session reset / key-rotation to avoid stale tokens.
 */
export function clearSbKeys(): void {
  try {
    Object.keys(localStorage).forEach((k) => {
      if (k.startsWith("sb-")) localStorage.removeItem(k);
    });
  } catch {
    void 0; /* ignore localStorage errors during clear */
  }
}
